<template>
	<li class="eia-list-item">
		<slot></slot>
	</li>
</template>

<script>
export default {
	name: 'eia-list-item',
};
</script>

<style lang="scss" scoped>
.eia-list-item {
	line-height: 24px;
}
</style>
